import React, { useState, useEffect } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Typography, Button, Modal, TextField, MenuItem, IconButton, Grid, CircularProgress } from '@mui/material';

export default function BookingSourceFormModal({ open, onClose, onSave, editingSource = null, loading = false }) {
    const defaultState = { name: '', type: 'Direct', status: 'Active' };
    const [formData, setFormData] = useState(defaultState);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (open) {
            setFormData(editingSource || defaultState);
            setErrors({});
        }
    }, [open, editingSource]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: null }));
        }
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.name.trim()) newErrors.name = 'Source name is required';

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = () => {
        if (validateForm()) {
            onSave(formData);
        }
    };

    return (
        <Modal open={open} onClose={loading ? null : onClose} disableEscapeKeyDown>
            <Box sx={{
                position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
                width: { xs: '90%', sm: 400 }, bgcolor: 'background.paper', borderRadius: 3, p: 4, boxShadow: 24,
                display: 'flex', flexDirection: 'column', gap: 2.5
            }}>
                <IconButton 
                    sx={{ position: 'absolute', top: 12, right: 12 }} 
                    onClick={onClose}
                    disabled={loading}
                >
                    <CloseIcon />
                </IconButton>

                <Typography variant="h6" fontWeight="bold">
                    {editingSource ? 'Edit Booking Source' : 'Add Booking Source'}
                </Typography>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Source Name"
                            name="name"
                            placeholder="e.g. Booking.com, Expedia, Direct"
                            value={formData.name}
                            onChange={handleChange}
                            error={!!errors.name}
                            helperText={errors.name}
                            disabled={loading}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            select
                            fullWidth
                            label="Status"
                            name="status"
                            value={formData.status}
                            onChange={handleChange}
                            disabled={loading}
                        >
                            <MenuItem value="Active">Active</MenuItem>
                            <MenuItem value="Inactive">Inactive</MenuItem>
                        </TextField>
                    </Grid>
                </Grid>

                <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
                    <Button 
                        fullWidth 
                        variant="outlined" 
                        color="error" 
                        onClick={onClose} 
                        size="large"
                        disabled={loading}
                    >
                        Cancel
                    </Button>
                    <Button 
                        fullWidth 
                        variant="contained" 
                        onClick={handleSubmit} 
                        size="large"
                        disabled={loading}
                        startIcon={loading && <CircularProgress size={20} color="inherit" />}
                    >
                        {loading ? 'Saving...' : editingSource ? 'Update' : 'Create'}
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
}
